import { defineLanguage } from "../registry";

// gofmt indents with tabs.
export default defineLanguage({
  id: "go",
  runner: "go",
  config: { indent: { tabs: true, size: 4 } },
});
